/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Tonne_SessionInputs */

const en_us2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten tonnes`)
};

const pt_br2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonelada`)
};

const es_419_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diez toneladas`)
};

const pt_pt2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dez toneladas`)
};

const fr_fr2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dix tonnes`)
};

const de_de2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zehn Tonnen`)
};

const it_it2_achievement_tonne_session = /** @type {(inputs: Achievement_Tonne_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieci tonnellate`)
};

/**
* | output |
* | --- |
* | "Ten tonnes" |
*
* @param {Achievement_Tonne_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_tonne_session = /** @type {((inputs?: Achievement_Tonne_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Tonne_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_tonne_session(inputs)
	if (locale === "es-419") return es_419_achievement_tonne_session(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_tonne_session(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_tonne_session(inputs)
	if (locale === "de-DE") return de_de2_achievement_tonne_session(inputs)
	if (locale === "it-IT") return it_it2_achievement_tonne_session(inputs)
	return en_us2_achievement_tonne_session(inputs)
});
export { achievement_tonne_session as "achievement.tonne_session" }